import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import axiosInstance from '../../utils/axios';
import Swal from 'sweetalert2';
import { getRole } from '../../utils/role';

const WaterReportUpdateModal = ({ show, handleClose, report, onSuccess }) => {

  const [formData, setFormData] = useState({
    tds: '',
    carbonate: '',
    bicarbonate: ''
  });

  const [loading, setLoading] = useState(false);
  const role = getRole();

  useEffect(() => {
    if (report) {
      setFormData({
        tds: report.tds ?? '',
        carbonate: report.carbonate ?? '',
        bicarbonate: report.bicarbonate ?? ''
      });
    }
  }, [report]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...report,
      ...formData,
      value_type: 'RAW',
      sample_type: 'WATER'
    };

    const endpoint = (role === 'PARTNER' || role === 'TEAM_MEMBER')
      ? '/admin/update-water-report' 
      : '/field-officer/update-water-report';

    try {
      await axiosInstance.put(endpoint, payload);
      Swal.fire('Success', 'Water report recommendations updated successfully.', 'success');
      onSuccess();
      handleClose();
    } catch (error) {
      Swal.fire('Error', error.response?.data?.msg || 'Failed to update report', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Water Report</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="text-muted mb-4">
            Sample ID: <strong>{report?.sample_id}</strong>
          </p>
          
          <Form.Group className="mb-3">
            <Form.Label>TDS</Form.Label>
            <Form.Control 
              type="number" 
              name="tds" 
              value={formData.tds} 
              onChange={handleChange} 
              required 
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Carbonate</Form.Label>
            <Form.Control 
              type="number" 
              name="carbonate" 
              value={formData.carbonate} 
              onChange={handleChange} 
              required 
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Bicarbonate</Form.Label>
            <Form.Control 
              type="number" 
              name="bicarbonate" 
              value={formData.bicarbonate} 
              onChange={handleChange} 
              required 
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="dark" type="submit" disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Update'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default WaterReportUpdateModal;